import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGithubsponsorsComponent } from './simple-icons-githubsponsors.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGithubsponsorsComponent ],
    exports:      [ SimpleIconsGithubsponsorsComponent ],
    bootstrap:    []
})
export class SimpleIconsGithubsponsorsModule {}
